import type { PageThemeDefinition } from "./types";
import { lightTheme } from "./themes/light";
import { darkTheme } from "./themes/dark";
import { designTheme } from "./themes/design";
import { oceanTheme } from "./themes/ocean";
import { emeraldTheme } from "./themes/emerald";
import { amberTheme } from "./themes/amber";
import { roseTheme } from "./themes/rose";
import { gpTheme } from "./themes/gp";
import { ggTheme } from "./themes/gg";
import { gtTheme } from "./themes/gt";
import { g7Theme } from "./themes/g7";

export const DEFAULT_THEME_ID = "light";
/** V2 页面默认走设计稿主题 */
export const DEFAULT_V2_THEME_ID = "design";

/**
 * 新增主题：在 themes/ 下新建 xxx.ts，补全 PageThemeTokens（布局同 design 时复制 design 改色），
 * 再 push 到 THEME_LIST，并在 tm-platfrom pageThemeManifest 注册预览。
 */
const THEME_LIST: PageThemeDefinition[] = [
  lightTheme,
  darkTheme,
  designTheme,
  oceanTheme,
  emeraldTheme,
  amberTheme,
  roseTheme,
  gpTheme,
  ggTheme,
  gtTheme,
  g7Theme,
];

const registry = new Map(THEME_LIST.map((theme) => [theme.id, theme]));

export function resolveTheme(id?: string): PageThemeDefinition {
  if (id && registry.has(id)) {
    return registry.get(id)!;
  }
  if (process.env.NODE_ENV === "development" && id) {
    console.warn(`[pageTheme] unknown theme id "${id}", fallback to ${DEFAULT_THEME_ID}`);
  }
  return registry.get(DEFAULT_THEME_ID)!;
}

/** V2 路由专用：未配置时回退 design，而非 light/dark */
export function resolveV2Theme(id?: string): PageThemeDefinition {
  if (id && registry.has(id)) {
    return registry.get(id)!;
  }
  return registry.get(DEFAULT_V2_THEME_ID)!;
}

export function listPageThemes(): PageThemeDefinition[] {
  return [...THEME_LIST];
}

export function isValidThemeId(id: string): boolean {
  return registry.has(id);
}
